// extracted by mini-css-extract-plugin
module.exports = {"articlesLargeRowItem":"_19ASvS-R","articlesRowItem":"_3ffefbyU","emptyStateIcon":"lI2Mdm8M","topContributingInfoImage":"_3VGwzDtc","avatar":"_3WMzvzBl","footerDot":"tLMr1atl"};